<template>
  <card>
    <h4 slot="header" class="card-title">Yeni Kumbara</h4>
    <a-form-model
      ref="ruleForm"
      :model="moneybox"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      >
      <a-form-model-item ref="code" label="Kumbara Kodu" prop="code">
        <a-input
          placeholder="Kumbara Kodu"
          v-model="moneybox.code"
          @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="name" label="Kumbara Adı" prop="name">
        <a-input
          placeholder="Kumbara Adı"
          v-model="moneybox.name"
          @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item ref="description" label="Detay" prop="description">
        <a-textarea
          v-model="moneybox.description"
          placeholder="Detay"
        />
      </a-form-model-item>
      <a-form-model-item label="İşletme" prop="corporation_id">
        <a-select
          show-search
          allowClear
          placeholder="İşletme seçiniz"
          v-model="moneybox.corporation_id"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="corp in corporations"
            :value="corp.id"
            :key="corp.id"
          >
            {{ corp.corporation_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        help="Kaç günde bir boşaltma işlemi yapılması gerektiği bilgisini ifade eder."
        ref="unload_interval"
        label="Boşaltma Periyodu"
        prop="unload_interval">
        <a-input-number
          placeholder="Periyot"
          v-model="intervalValue"
          :min="1"
          :max="100" />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
        <a-button :loading="loading" type="primary" @click="onSubmit">
          Güncelle
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          Sıfırla
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'

  export default {
    props: ["moneybox"],
    components: {
      Card
    },
    watch:{
      "moneybox.code": {
        handler(newV, oldV){
          this.$emit("codeChange", newV)
        }
      },
    },

    data () {
      // The interval comes back as its own object ({interval, id, ...}, or
      // null if never configured) rather than a plain number, since it's
      // stored in its own append-only table - see the backend's
      // UnloadMoneyboxIntervalStore. Pull the number out into its own field
      // so the input can bind to it directly, and keep the original value
      // around to detect whether the user actually changed it on submit.
      const initialInterval = this.moneybox.unload_interval ? this.moneybox.unload_interval.interval : null

      // A moneybox is linked to a corporation through a separate assignment
      // record (there is no corporation_id column on moneyboxes), so pull
      // the current one out the same way, and remember its assignment id -
      // needed to delete it if the user picks a different corporation.
      const currentAssignment = (this.moneybox.corporation_moneybox_assignments && this.moneybox.corporation_moneybox_assignments[0]) || null
      // moneybox is a prop object Vue already made reactive; adding a brand
      // new key to it with a plain assignment would not be tracked, so the
      // select wouldn't update when the user picks an option - $set fixes that.
      this.$set(this.moneybox, 'corporation_id', currentAssignment ? currentAssignment.corporation_id : undefined)

      return {
        corporations: [],
        loading: false,
        intervalValue: initialInterval,
        originalIntervalValue: initialInterval,
        originalCorporationId: this.moneybox.corporation_id,
        originalAssignmentId: currentAssignment ? currentAssignment.id : null,
        labelCol: { span: 4 },
        wrapperCol: { span: 10 },
        rules: {
          code: [
            { required: true, message: 'Kod alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 50, message: 'Kod alanı min 3, max 50 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          name: [
            { required: true, message: 'Kumbara Adı alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 50, message: 'Kumbara Adı alanı min 3, max 50 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          description: [
            { required: false, message: 'Detay alanını boş bırakmayınız', trigger: 'blur' },
            { min: 3, max: 500, message: 'Detay alanı min 3, max 500 karakter uzunluğunda olabilir', trigger: 'blur' },
          ],
          corporation_id: [
            { required: true, message: 'İşletme seçimi zorunludur', trigger: 'change' },
          ],
        },
      }
    },
    mounted() {
      this.$store.dispatch('Corporation/requestCorporationList').then((res) => {
        this.corporations = res.corporations || []
      })
    },
    methods: {
      filterOption(input, option) {
        return option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      },
      onSubmit() {
        const self = this
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            self.loading = true
            const { unload_interval: _, corporation_id: __, corporation_moneybox_assignments: ___, ...data } = self.moneybox;
            self.$store.dispatch("Moneybox/requestMoneyboxUpdate", data).then((moneybox)=> {
              self.$notification['success']({
                message: 'Kumbara Güncelleme',
                description:
                  'Kumbara başarılı bir şekilde güncellendi 😊',
              });

              const intervalChanged = self.intervalValue !== self.originalIntervalValue
              if (intervalChanged && self.intervalValue) {
                self.$store.dispatch("Moneybox/requestMoneyboxUnloadIntervalCreate", {
                  moneybox_id: moneybox.id,
                  interval: self.intervalValue
                })
              }

              const corporationChanged = self.moneybox.corporation_id !== self.originalCorporationId
              if (corporationChanged) {
                if (self.originalAssignmentId) {
                  self.$store.dispatch("Corporation/requestCorporationMoneyboxAssignmentDelete", {
                    corporation_id: self.originalCorporationId,
                    assignment_id: self.originalAssignmentId,
                  })
                }
                if (self.moneybox.corporation_id) {
                  self.$store.dispatch("Corporation/requestCorporationMoneyboxAssignmentCreate", {
                    corporation_id: self.moneybox.corporation_id,
                    selected_moneyboxes: [{ key: moneybox.id }],
                  })
                }
              }

              self.$router.push('/admin/money-boxes/')
            }).catch(()=> {
              self.$notification['error']({
                message: 'Kumbara Güncelleme',
                description:
                  'Kumbara güncellenirken bir hata oluştu :/',
              });
            }).finally(()=> {
              self.loading = false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm() {
        this.$refs.ruleForm.resetFields();
      }
    }
  }

</script>
<style>

</style>
